/**
 * 📌 Script: modulesStore.js
 * 📂 Caminho: src/stores/modulesStore.js
 * 📝 Descrição: Pinia store simples para armazenar/fornecer as permissões de módulos
 *    do usuário carregadas a partir do documento `users` no Firestore.
 *
 * 🔄 Relação com o Projeto:
 *  - Consumido por views e guardas de rota para controlar acesso a módulos (ex.: StartseiteView, router).
 *  - Usado para habilitar/desabilitar navegação e botões conforme permissões do usuário.
 *
 * 📥 Entradas (Parâmetros):
 *  - Nenhum parâmetro externo; recebe um objeto `permissions` (mapa chave->boolean) via ação.
 *
 * 📤 Saídas:
 *  - Estado reativo `permissions` (Object) contendo permissões por módulo.
 *
 * 🧩 Exports:
 *  - `useModulesStore()` - Pinia store factory que expõe estado e ações.
 *    - state.permissions (Object) - mapa de permissões carregadas.
 *    - action `setPermissions(permissions)` - atualiza o estado de permissões.
 *
 * 🔗 Dependências:
 *  - **Bibliotecas externas:** `pinia` (`defineStore`).
 *  - **Consumidores:** router (beforeEach), StartseiteView e componentes que verificam permissões.
 *
 * ⚠️ Observações:
 *  - Este store contém apenas autorização no frontend; regras de segurança sensíveis devem estar
 *    reforçadas no backend / regras do Firestore.
 */

import { defineStore } from "pinia";

export const useModulesStore = defineStore("modulesStore", {
  state: () => ({
    permissions: {}, // Permissões carregadas do Firestore
  }),
  actions: {
    setPermissions(permissions) {
      this.permissions = permissions || {};
    },
  },
});
